import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

export function sendUpdate(notarizationId, documentId, connectionId, payload) {
	return Auth.POST(url(notarizationId, documentId, connectionId), payload);
}

// Private
function url(notarizationId, documentId, connectionId) {
	return `/pdf-annotations/${notarizationId}/${documentId}?connectionId=${connectionId}`;
}